// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"Cu","replayButton":"Cv","cta":"Cw","replayIcon":"Cx","buttonWrapper":"Cy"};